import { AuthState, OktaAuthOptions } from '@okta/okta-auth-js';
import { UserAPI } from 'api/user';
import { LS_TEMPLATE_ID_KEY } from 'constant/constant';
import { ApiKey, logger, TokenType } from 'services';
import { logout } from 'utils/logout';

const SCOPES = ['offline_access', 'openid', 'profile', 'email'];

const authState = (_authState: AuthState, error?: any): AuthState => ({
  isAuthenticated: ApiKey.exists(),
  error,
});

const logAndReturnAuthState = (state: AuthState, error?: any): AuthState => {
  const result = authState(state, error);

  logger.debug('transformed auth state', { result });

  return result;
};

export const OKTA_REDIRECT_URI = window.location.origin;
export const CONFIG = (
  issuer: string,
  clientId: string,
  redirect_uri = OKTA_REDIRECT_URI,
): OktaAuthOptions => ({
  issuer,
  clientId,
  redirectUri: `${redirect_uri}/implicit/callback`,
  scopes: SCOPES,
  pkce: true,
  tokenManager: {
    autoRenew: false,
    autoRemove: false,
  },
  postLogoutRedirectUri: `${redirect_uri}/login`,
  transformAuthState: async (_, state) => {
    const params = new URLSearchParams(window.location.search);

    if (params.get('templateId')) {
      localStorage.setItem(
        LS_TEMPLATE_ID_KEY,
        params.get('templateId') as string,
      );
    }
    logger.debug(
      'transform auth state called',
      state as Record<string, unknown>,
    );
    const authenticated = ApiKey.exists();

    if (!authenticated && state.accessToken != null) {
      try {
        await ApiKey.create(state.accessToken.accessToken, TokenType.Okta);
      } catch (error) {
        logger.error('api key creation failed', { error });

        return logAndReturnAuthState(state, error);
      }
      try {
        await UserAPI.clearOktaSession();
      } catch (error) {
        logger.error('could not clear okta session via API, logging out', {
          error,
        });
        logout();
      }
    }

    return logAndReturnAuthState(state);
  },
});
